import { IconArchive } from "@tabler/icons-react";

import { TruncatedTextWithTooltip } from "~/components/_design-system/text/TruncatedTextWithTooltip";
import { Flex, Text, Tooltip } from "~/ui";
import { convertDateToString } from "~/utils/datetime";

interface ArchivableLabelCellProps {
  archivedAt: Date | null;
  label: string | JSX.Element;
  /** When true, applies single-line ellipsis to the label and ensures it can shrink inside a flex row. */
  truncate?: boolean;
  /** Optional tooltip text shown when hovering the label. Pass an empty string to intentionally render no content. */
  tooltipLabel?: string;
  /** Optional native title attribute for the label element (useful as an accessible fallback). */
  title?: string;
}
export const ArchivableLabelCell = ({ archivedAt, label, truncate = false, tooltipLabel, title }: ArchivableLabelCellProps) => {
  const isString = typeof label === "string";

  return (
    <Flex align="center" direction="row" style={{ minWidth: 0 }}>
      {isString ? (
        <TruncatedTextWithTooltip
          text={label}
          truncate={truncate}
          tooltipLabel={tooltipLabel ?? title ?? label ?? ""}
          titleFallback={false}
          textProps={{ fw: 500, style: truncate ? { minWidth: 0, flex: 1 } : undefined }}
          tooltipProps={{ withinPortal: true, position: "top", withArrow: true, openDelay: 100 }}
        />
      ) : (
        <Text fw={500} style={truncate ? { minWidth: 0, flex: 1 } : undefined} title={title}>
          {label}
        </Text>
      )}
      {archivedAt ? (
        <Flex ml="xs" mt={-2} style={{ flexShrink: 0 }}>
          <Tooltip label={`Archived on ${convertDateToString(archivedAt)}`} withArrow withinPortal>
            <IconArchive color="gray" size={18} />
          </Tooltip>
        </Flex>
      ) : null}
    </Flex>
  );
};
